export class BaseLayerOptions {
    type?: any;
    customFilters?: any;
    layerBefore?: string;
    opacity?: any;

    visibleFrom?: number;
    visibleTo?: number;

    visibility?: boolean;
}
